import Footer from "@/components/Footer";
import CustomCursor from "../components/animatedComponents/CustomCursor";
import LightSpots from "../components/animatedComponents/LightSpots";
import ServiceSTS from "@/components/ServiceSTS";
import Navbar from "@/components/Navbar";

const ServicesSTS = () => {
  return (
    <div className="min-h-screen bg-[#f5f5f5] relative overflow-x-hidden">
      {/* Custom Cursor */}
      <CustomCursor />

      {/* Light Spots Background */}
      <LightSpots />

      {/* Main Layout */}
      <div className="relative z-10 min-h-screen">
        <Navbar initialColor={"[#0d1821]"} />
        <main>
          <div id="smooth-wrapper">
            <div id="smooth-content" className="min-h-screen">
              <ServiceSTS />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default ServicesSTS;
